module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921051151_T.d3328a9d.jpg";